import { render, staticRenderFns } from "./SelecaoCategoria.vue?vue&type=template&id=7b9af26e&"
import script from "./SelecaoCategoria.vue?vue&type=script&lang=js&"
export * from "./SelecaoCategoria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports